import React from "react";
import { SHOP_PIN_COLORS } from "./shopMapPopupCard";

function LegendPin({ color }) {
  return (
    <svg viewBox="0 0 24 34" width="13" height="18" aria-hidden="true" style={{ flex: "0 0 auto" }}>
      <path
        d="M12 33S2 23.9 2 12.5C2 6.4 6.5 2 12 2s10 4.4 10 10.5C22 23.9 12 33 12 33Z"
        fill={color}
        stroke="#ffffff"
        strokeWidth="1.5"
      />
    </svg>
  );
}

// Shared map key for the shop pins, used on Shop Explorer and Car Request so customers can tell a
// fixed storefront (visit them) from a mobile mechanic's general service area (comes to you).
export default function MapLegend({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-600 dark:text-gray-300 ${className}`}>
      <span className="inline-flex items-center gap-1.5">
        <LegendPin color={SHOP_PIN_COLORS.shop} />
        Shop - visit this location
      </span>
      <span className="inline-flex items-center gap-1.5">
        <LegendPin color={SHOP_PIN_COLORS.mobile} />
        Mobile mechanic - comes to you (general service area)
      </span>
    </div>
  );
}
